/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BreadcrumbItem } from './BreadcrumbItem';
import {
    BreadcrumbItemFromJSON,
    BreadcrumbItemFromJSONTyped,
    BreadcrumbItemToJSON,
} from './BreadcrumbItem';

/**
 * Provides navigation information, i.e. the parent(s) for the current page. [show only]
 * @export
 * @interface Breadcrumbs
 */
export interface Breadcrumbs {
    /**
     * Items, either of type Breadcrumb or HierarchyGroup
     * @type {Array<BreadcrumbItem>}
     * @memberof Breadcrumbs
     */
    items: Array<BreadcrumbItem>;
}

/**
 * Check if a given object implements the Breadcrumbs interface.
 */
export function instanceOfBreadcrumbs(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function BreadcrumbsFromJSON(json: any): Breadcrumbs {
    return BreadcrumbsFromJSONTyped(json, false);
}

export function BreadcrumbsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Breadcrumbs {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(BreadcrumbItemFromJSON)),
    };
}

export function BreadcrumbsToJSON(value?: Breadcrumbs | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(BreadcrumbItemToJSON)),
    };
}

